// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-1000000,.btn-2000000,.btn-3000000,.btn-5000000,.btn-10000000{background-color:#fff!important}.btn-1000000 span,.btn-2000000 span,.btn-3000000 span,.btn-5000000 span,.btn-10000000 span{font-family:vazir!important;font-weight:700!important}", ""]);
// Exports
module.exports = exports;
